import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Infinity, AlertCircle } from 'lucide-react';
const stats = [{
  Icon: Clock,
  value: '40',
  unit: 'semanas',
  label: 'al año sin material nuevo',
  desc: 'Búsquedas en internet, capturas de pantalla y carpetas sin orden. Y el lunes la clase igual.'
}, {
  Icon: Infinity,
  value: '∞',
  unit: 'horas',
  label: 'armando evaluaciones',
  desc: 'Crear rúbricas desde cero para cada trabajo, cada nivel y cada grupo, sin un sistema.'
}, {
  Icon: AlertCircle,
  value: '1',
  unit: 'problema',
  label: 'constante: el doble nivel',
  desc: 'Si das Primaria y Secundaria, es doble planificación, doble material, doble tiempo perdido.'
}];
export function HiddenCost() {
  return <section className="py-24 lg:py-32 bg-paper-alt" data-id="element-121">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-123">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-100" data-id="element-124">
            HABLEMOS EN SERIO
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-125">
            El verdadero costo de{' '}
            <span className="text-brand-500" data-id="element-126">
              improvisar tus clases de Arte
            </span>
          </h2>
          <p className="text-lg text-ink-600 font-normal leading-relaxed" data-id="element-127">
            No es solamente tiempo. Es sentir que podrías dar mucho más si
            tuvieras una planificación clara.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-128">
          {stats.map((s, i) => {
          const Icon = s.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.8,
            ease: 'easeOut'
          }} className="group bg-paper-card rounded-[20px] p-8 lg:p-10 shadow-soft border border-paper-border transition-shadow hover:shadow-card" data-id="element-129">
                <div className="w-14 h-14 rounded-full bg-brand-50 text-brand-500 flex items-center justify-center mb-8" data-id="element-130">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-131" />
                </div>
                <div className="flex items-baseline gap-2 mb-3" data-id="element-132">
                  <span className="text-5xl md:text-6xl font-serif font-medium text-ink-800 leading-none" data-id="element-133">
                    {s.value}
                  </span>
                  <span className="text-sm font-medium text-ink-500 uppercase tracking-widest" data-id="element-134">
                    {s.unit}
                  </span>
                </div>
                <div className="text-lg font-medium text-brand-500 mb-4" data-id="element-135">
                  {s.label}
                </div>
                <p className="text-ink-600 leading-relaxed text-sm font-normal" data-id="element-136">
                  {s.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}